import { render } from "./EventEdit.vue?vue&type=template&id=4fddd9cb&scoped=true"
import script from "./EventEdit.vue?vue&type=script&lang=js"
export * from "./EventEdit.vue?vue&type=script&lang=js"

import "./EventEdit.vue?vue&type=style&index=0&id=4fddd9cb&scoped=true&lang=css"
import "./EventEdit.vue?vue&type=style&index=1&id=4fddd9cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fddd9cb"]])

export default __exports__